@if (Loading) {
<div class="loading">Loading...</div>
} @else {
<div class="section">
  <h4>Customer</h4>
  <div class="field-grid">
    <div class="field-group span-2">
      <rms-search-select label="Customer *"
                         [options]="Customers"
                         labelKey="LabelName"
                         valueKey="CompanyID"
                         [disabled]="Saving"
                         [(ngModel)]="CompanyID">
      </rms-search-select>
    </div>
    <div class="field-group">
      <label>Trader</label>
      <select [(ngModel)]="TraderID" [disabled]="Saving">
        <option [ngValue]="null">—</option>
        @for (t of Traders; track t.TraderID) {
        <option [ngValue]="t.TraderID">{{ t.FullName }}</option>
        }
      </select>
    </div>
    <div class="field-group">
      <label>Purchase Date</label>
      <input type="date" [(ngModel)]="PurchaseDate" [disabled]="Saving" />
    </div>
  </div>
</div>

<div class="section">
  <h4>Futures Contract</h4>
  <div class="field-grid">
    <div class="field-group span-2">
      <label>Futures Month *</label>
      <select [ngModel]="FutureCompositeID" (ngModelChange)="onMonthChanged($event)" [disabled]="Saving">
        <option [ngValue]="null">Select a month</option>
        @for (m of Months; track m.FutureCompositeID) {
        <option [ngValue]="m.FutureCompositeID">{{ m.Label }}</option>
        }
      </select>
    </div>
    <div class="field-group">
      <label>Weight (lbs) *</label>
      <input type="number" min="1" [(ngModel)]="WeightLbs" [disabled]="Saving || !FutureCompositeID" />
      <div class="quick-weights">
        <button type="button" class="link-btn" (click)="setContracts(0.5)" [disabled]="Saving || !FutureCompositeID">½ contract</button>
        <button type="button" class="link-btn" (click)="setContracts(1)" [disabled]="Saving || !FutureCompositeID">1 contract</button>
        <button type="button" class="link-btn" (click)="setContracts(2)" [disabled]="Saving || !FutureCompositeID">2 contracts</button>
      </div>
    </div>
    <div class="field-group">
      <label>Price / {{ unitLabel }}</label>
      <input type="number" min="0" step="0.0001" [(ngModel)]="Price" [disabled]="Saving" />
      @if (priceWarning) {
      <span class="field-hint price-warning">{{ priceWarning }}</span>
      }
    </div>
    <div class="field-group">
      <label>Exchange</label>
      <div class="value">{{ exchange?.ExchangeName ?? '—' }}</div>
    </div>
    <div class="field-group">
      <label>Contract Size</label>
      <div class="value">{{ exchange ? (contractWeight | number:'1.0-0') + ' lbs' : '—' }}</div>
    </div>
    <div class="field-group">
      <label>Contracts</label>
      <div class="value">{{ lots | number:'1.2-2' }}</div>
    </div>
    <div class="field-group">
      <label>Terminal Allocation</label>
      <select [(ngModel)]="TerminalID" [disabled]="Saving">
        <option [ngValue]="null">—</option>
        @for (t of Terminals; track t.TerminalID) {
        <option [ngValue]="t.TerminalID">{{ t.TerminalName }}</option>
        }
      </select>
    </div>
    <div class="field-group span-4">
      <label>Contract Note</label>
      <textarea [(ngModel)]="ContractNote" maxlength="2000" rows="3" [disabled]="Saving"></textarea>
    </div>
  </div>
</div>

<div class="form-actions">
  <button class="btn-bg-red" (click)="cancel()" [disabled]="Saving">Cancel</button>
  <button class="btn-bg-green" (click)="save()" [disabled]="!canSave">
    {{ Saving ? 'Creating...' : 'Create Futures Contract' }}
  </button>
</div>
}
